function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
const SvgIconGeneric = props => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 36"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 13.2H31V8.4v-.1-.1-.1V8l-.1-.1L23.3.3l-.1-.1h-.1-.1-.1-.1H5.7C5.3 0 5 .4 5 .8v12.4H1.8c-.4 0-.8.4-.8.8v7.3c0 .5.4.8.8.8H5v13c0 .5.3.9.7.9h24.6c.4 0 .8-.4.8-.8v-13h3.2c.5 0 .8-.4.8-.8V14c-.1-.4-.5-.8-.9-.8zM23.5 2.6l5 5h-5v-5zm6 31.9h-23V22.2h10.4v-6.9h2.2v6.9h10.4v12.3zm0-21.3h-23V1.5H22v6.9c0 .4.3.8.8.8h6.8v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 25.2l-1.6 1.5 3.1 3.1 1.6 1.6 1.6-1.6 3.1-3.1-1.6-1.5-2 2v-5h-2.2v5z"
  }));
};
SvgIconGeneric.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  fill: PropTypes.string,
  label: PropTypes.string
} : {};
export default SvgIconGeneric;